import type { FloodTerrain } from "../map/floodScenario";
import { useT } from "../hooks/useLang";

interface Props {
  compact?: boolean;
  terrain: FloodTerrain | null;
  rise: number;
  onRise: (rise: number) => void;
  exposed: number;
  unknown: number;
}
export function FloodScenarioControl({ compact = false, terrain, rise, onRise, exposed, unknown }: Props) {
  const t = useT();
  return <details className="flood-scenario-control" aria-label="Flood terrain scenario" open={!compact}>
    <summary>{t("Terrain scenario", "สถานการณ์จำลองภูมิประเทศ")} · +{rise.toFixed(1)} m</summary>
    {!terrain ? <p role="status">{t("Terrain unavailable — no simulated extent", "ไม่มีข้อมูลภูมิประเทศ — ไม่แสดงพื้นที่จำลอง")}</p> : <>
      <label htmlFor="scenario-river-rise">{t("Rise above DEM river reference", "น้ำสูงขึ้นจากแนวอ้างอิงแม่น้ำใน DEM")}</label>
      <input id="scenario-river-rise" aria-label="Scenario river rise" type="range" min="0" max="8" step="0.5" value={rise} onChange={e => onRise(Number(e.target.value))} />
      <output className="scenario-result" aria-label="Scenario exposed buildings" aria-live="polite"><strong>{exposed.toLocaleString()}</strong> {t("building centroids in wet cells", "จุดกึ่งกลางอาคารอยู่ในพื้นที่จำลอง")}</output>
      <p>{t("Amber walls = exposed footprint centroids", "ผนังสีอำพัน = จุดกึ่งกลางอาคารในพื้นที่จำลอง")}</p>
      <p>{t("Planning only · ≈33 m grid · not observed flooding", "ใช้สำรวจแผนเท่านั้น · กริด ≈33 ม. · ไม่ใช่น้ำท่วมที่ตรวจพบ")}</p>
      <details className="scenario-method"><summary>{t("Sources & limits", "แหล่งข้อมูลและข้อจำกัด")}</summary>
        <p>{terrain.source}. {terrain.terrainEpoch}. {t("Prepared", "จัดทำ")} {terrain.acquired}.</p>
        <p>{t("Relative to local DEM channel elevation, not gauge zero. Connected low ground only; no calibrated hydraulics, levees, culverts or drains. Colours show relative surface clearance, not surveyed water depth.", "อ้างอิงระดับพื้นแม่น้ำใน DEM ไม่ใช่ศูนย์มาตรวัดน้ำ แสดงเฉพาะพื้นที่ต่ำที่เชื่อมถึงแม่น้ำ ไม่ได้คำนวณชลศาสตร์ คันกั้นน้ำ ท่อลอด หรือระบบระบายน้ำ สีไม่ใช่ความลึกที่สำรวจจริง")}</p>
        <p>{t("Unknown terrain footprints", "อาคารที่ไม่ทราบระดับพื้น")}: {unknown.toLocaleString()}.</p>
      </details>
    </>}
  </details>;
}
